import React from 'react';
import { Link } from 'react-router-dom';
import { Package, TrendingDown } from 'lucide-react';
import { BULK_TIERS } from '../utils/pricing';

export const BulkPricingSection = () => {
  return (
    <section className="py-24 px-6 lily-bulk-bg" data-testid="bulk-pricing-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
            Special Bulk Pricing
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-brand-green-dark mb-4">
            Buy More, Save More
          </h2>
          <p className="font-body text-base sm:text-lg leading-relaxed font-light text-brand-green-dark/80 max-w-2xl mx-auto">
            Perfect for events, weddings, and celebrations. Enjoy tiered discounts on every A-Grade lily order.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {BULK_TIERS.map((tier, idx) => (
            <div
              key={`bulk-section-tier-${tier.discount}`}
              className="bg-brand-cream border border-brand-gold/40 p-10 rounded-sm text-center hover:shadow-xl smooth-transition"
              data-testid={`bulk-tier-${tier.discount}`}
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 rounded-full bg-brand-gold/15 flex items-center justify-center">
                  {idx === 0 && <Package className="w-8 h-8 text-brand-gold" strokeWidth={1.5} />}
                  {idx === 1 && <TrendingDown className="w-8 h-8 text-brand-gold" strokeWidth={1.5} />}
                  {idx === 2 && <Package className="w-8 h-8 text-brand-gold" strokeWidth={1.5} />}
                </div>
              </div>

              <p className="font-heading text-6xl text-brand-green mb-2">
                {tier.discount}%
              </p>
              <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
                Off Per Stem
              </p>
              <p className="font-body text-lg text-brand-green-dark mb-3">
                {tier.label}
              </p>
              <p className="font-body text-sm text-brand-green-dark/60">
                Discount auto-applied at checkout
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/products"
            className="inline-block bg-brand-gold text-brand-green-dark px-12 py-4 rounded-sm font-body uppercase tracking-[0.2em] text-sm font-bold hover:bg-brand-green hover:text-brand-cream smooth-transition"
            data-testid="shop-bulk-btn"
          >
            Order Bulk Now
          </Link>
        </div>
      </div>
    </section>
  );
};
